"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const SliderField = ({
  id,
  disabled,
  readonly,
  label,
  value,
  step,
  min,
  max,
  marks,
  onChange
}) => {
  const handleChange = (event, value) => {
    console.log('slide', value);
    onChange && onChange(value, event);
  };

  const getAriaValue = value => {
    return value;
  };

  return _react.default.createElement(_FormControl.default, {
    component: "fieldset",
    fullWidth: true
  }, _react.default.createElement(_FormLabel.default, {
    component: "legend"
  }, label), _react.default.createElement(_Slider.default, {
    id: id,
    disabled: disabled,
    defaultValue: value,
    getAriaValueText: getAriaValue,
    "aria-labelledby": id,
    valueLabelDisplay: "auto",
    step: step,
    marks: marks,
    min: min,
    max: max,
    onChange: handleChange
  }));
};

var _default = SliderField;
exports.default = _default;
module.exports = exports.default;